import { Sprint as SprintType } from 'api/sprint-planning/types';
import type { Task as TaskType } from 'data/tasks';
import type {
  ProjectTemplateSprint,
  ProjectTemplateTask,
} from 'data/templates/projects';

export enum PhaseEntityType {
  Task = 'TASK',
  Sprint = 'SPRINT',
}

export interface PhaseEntityMap {
  [PhaseEntityType.Task]: TaskType | ProjectTemplateTask;
  [PhaseEntityType.Sprint]: SprintType | ProjectTemplateSprint;
}

export type PhaseEntity = PhaseEntityMap[keyof PhaseEntityMap];

export type Filters = {
  [K in PhaseEntityType]: K extends keyof PhaseEntityMap
    ? (entity: PhaseEntityMap[K]) => boolean
    : never;
};

export interface PhaseEntityRendererProps {
  item: PhaseEntity;
  filters: Filters;
  type: PhaseEntityType;
}
